<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="copyright"></a>
<a id="page_iv"></a>
<p class="copyright1" id="copy_p1">The University of Chicago Press, Chicago, 60637<br/>
© 1967 by Richard Stark<br/>
Foreword © 2009 by Luc Sante<br/>
All rights reserved.<br/>
University of Chicago Press edition 2009</p>
<p class="copyright" id="copy_p2">Printed in the United States of America</p>
<p class="copyright" id="copy_p3">18 17 16 15 14 13 12 11 10 09     1 2 3 4 5</p>
<p class="copyright" id="copy_p4">ISBN-13: 978-0-226-77107-6 (paper)<br/>
ISBN-10: 0-226-77107-5 (paper)</p>
<p class="copyright" id="copy_p5">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright" id="copy_p6">Stark, Richard, 1933–2008.<br/>
 The rare coin score / Richard Stark ; with a new foreword by Luc Sante.<br/>
     p. cm.<br/>
 Summary: Parker makes the mistake of letting an amateur in on the score, and one of them is a pretty woman named Claire.<br/>
 ISBN-13: 978-0-226-77107-6 (pbk. : alk. paper)<br/>
 ISBN-10: 0-226-77107-5 (pbk. : alk. paper) 1. Parker (Fictitious character)—Fiction. 2. Criminals—Fiction. I. Sante, Luc. II. Title.<br/>
 PS3573.E9R37 2009<br/>
 813′.54—dc22</p>
<p class="copyright-right" id="copy_p7">2009006774</p>
<p class="copyright" id="copy_p8"><img alt="images" src="images/infin.jpg"/> The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1992.</p>
<p class="copyright" id="copy_p9">ISBN 978-0-226-77292-9 (electronic)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?31d827c0